import { useEffect, useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { Button } from 'src/components/system/Button';
import { listSimulations } from 'src/services/simulations';
import { toast } from 'react-toastify';
import { useCourseCategories } from 'src/contexts/CourseCategoriesContext';
import { formatSimulationStatus } from 'src/utils/simulationStatus';

const Page = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 32px 24px;
`;

const Card = styled.div`
  background: #fff;
  padding: 16px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.06);
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export function History() {
  const [items, setItems] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { categories } = useCourseCategories();
  const [searchParams] = useSearchParams();
  const familyParam = (searchParams.get('family') ?? '').trim();
  const normalizedFamilySlug = familyParam.toLowerCase();
  const familyCategory = useMemo(
    () => categories.find(item => (item.slug ?? '').toLowerCase() === normalizedFamilySlug),
    [categories, normalizedFamilySlug],
  );
  const familyLabel = familyCategory?.fullName ?? familyCategory?.name;
  const headerTitle = familyParam
    ? `Histórico - ${familyLabel ?? familyParam}`
    : 'Meus simulados';

  useEffect(() => {
    (async () => {
      try {
        const data = await listSimulations(familyParam || undefined);
        setItems(Array.isArray(data) ? data : []);
      } catch (error: any) {
        if (error?.response?.status === 401) {
          navigate('/auth/login');
          return;
        }
        toast.error('Não foi possível carregar o histórico de simulados.');
        setItems([]);
      } finally {
        setLoading(false);
      }
    })();
  }, [familyParam, navigate]);

  if (loading) return <Page>Carregando...</Page>;

  return (
    <Page>
      <h1>{headerTitle}</h1>
      {items.length === 0 && <div>Você não tem simulados realizados.</div>}
      {items.map((s) => {
        const percent = s.total > 0 ? Math.round((s.correct / s.total) * 100) : null;
        return (
          <Card key={s.id}>
            <div>
              <div><strong>Simulado #{s.id}</strong></div>
              <div>Status: {formatSimulationStatus(s.status)}</div>
              {percent !== null && <div>Resultado: {s.correct}/{s.total} ({percent}%)</div>}
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              {s.status === 'ongoing' ? (
                <Button
                  width="160px"
                  backgroundColor="#222B82"
                  borderColor="#222B82"
                  buttonColor="#fff"
                  onClick={() => navigate(`/simulate/${s.id}`)}
                  label={<span>Continuar</span>}
                />
              ) : (
                <Button
                  width="160px"
                  backgroundColor="#222B82"
                  borderColor="#222B82"
                  buttonColor="#fff"
                  onClick={() => navigate(`/results/${s.id}`)}
                  label={<span>Ver resultado</span>}
                />
              )}
            </div>
          </Card>
        );
      })}
    </Page>
  );
}
